import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  Textarea,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

type InventoryPosition = {
  id: number;
  name: string;
  note: string | null;
  code: string;
  active: boolean;
};

type ProvinceFormProps = {
  id?: string | number;
  onClose: any;
  isEditMode: boolean;
};

const ProvinceForm = ({ id, onClose, isEditMode }: ProvinceFormProps) => {
  const entity = {
    id: 0,
    name: "",
    note: "",
    code: "",
    active: false,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [enable, setEnable] = useState(false);

  const form = useForm<InventoryPosition>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      code: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập mã!";
        }
      },
      // codeprovinceweb: (value: string | null) => {
      //   if (!value) {
      //     return "Vui lòng nhập mã web!";
      //   }
      // },
      name: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên!";
        }
      },
    },
  });

  const handleSubmit = async (dataSubmit: InventoryPosition) => {
    open();
    const apiUrl = isEditMode
      ? `/api/v1/TblDmProvinceMoi/update`
      : `/api/v1/TblDmProvinceMoi/create`;
    const dataApi = await repositoryMdm.post<
      MessageResponse<InventoryPosition>
    >(apiUrl, dataSubmit);
    if (dataApi?.success) {
      onClose((prev: any) => !prev);
      modals.closeAll();
    }
    close();
  };

  const callApiGetData = async () => {
    if (!isEditMode) return;

    open();
    const callapi = await repositoryMdm.get<MessageResponse<InventoryPosition>>(
      `/api/v1/TblDmProvinceMoi/update?id=${id}`
    );

    if (!callapi?.success) {
      NotificationExtension.Fails("Bạn không có quyền sửa!!!");
      modals.closeAll();
      return;
    }

    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };

  useEffect(() => {
    if (id && isEditMode) {
      callApiGetData();
    }
  }, [id, isEditMode]);

  useEffect(() => {
    if (form.isDirty()) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [form]);

  return (
    <Box
      component="form"
      mx="auto"
      onSubmit={form.onSubmit((e: InventoryPosition) => {
        handleSubmit(e);
      })}
      style={{ position: "relative", width: "350px", height: "auto" }}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />

      <Grid mt={10}>
        <Grid.Col span={12}>
          <TextInput
            key={form.key("code")}
            label="Mã"
            placeholder="Mã"
            withAsterisk
            {...form.getInputProps("code")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label={"Tên"}
            placeholder={"Tên"}
            type="text"
            withAsterisk
            key={form.key("name")}
            {...form.getInputProps("name")}
          />
        </Grid.Col>
        {/* <Grid.Col span={12}>
          <TextInput
            label={"Mã web"}
            placeholder={"Nhập mã web"}
            type="text"
            withAsterisk
            key={form.key("codeprovinceweb")}
            {...form.getInputProps("codeprovinceweb")}
          />
        </Grid.Col> */}
        <Grid.Col span={12}>
          <Textarea
            label={"Ghi chú"}
            placeholder={"Ghi chú"}
            // withAsterisk
            key={form.key("note")}
            {...form.getInputProps("note")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Checkbox
            key={form.key("active")}
            label="Hoạt động"
            defaultValue={form.getValues().active ?? false}
            defaultChecked={form.getValues().active ?? false}
            {...form.getInputProps("active")}
          />
        </Grid.Col>
      </Grid>

      <Group
        justify="end"
        mt="xs"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          type="button"
          color="gray"
          loading={visible}
          onClick={() => {
            modals.closeAll();
          }}
        >
          Đóng
        </Button>
        <Button type="submit" loading={visible}>
          Lưu
        </Button>
      </Group>
    </Box>
  );
};

export default ProvinceForm;
